export const environment = {
  production: false,
  apiUrl: 'https://dev-api.rez.flights/',
  flightApi: 'https://dev-booking.rez.flights/',
  imageUrl: 'https://book-staging-bucket.s3.ap-south-1.amazonaws.com/',
  logoUrl: 'assets/images/rez-logo.svg',
  showOrgSettingsAllTabs: false,
  showWhitelabel: false,
  client: 'RezFlight',
  clientAbbr: 'REZ',
  clientShort: 'RezFlight',
  logoHeight: '35',
  numberFormat: 'en-IN',
  // Decimal places for every price (2 -> 1,500.00, 0 -> 1,500)
  numberDecimals: 2,
  whitelabelCustomJs: 'https://book-staging-bucket.s3.ap-south-1.amazonaws.com/whitelabel/custom.js',
  whitelabelStyleCss: 'https://book-staging-bucket.s3.ap-south-1.amazonaws.com/whitelabel/style.css'
};